<template>
  <div>
    <el-button class="add-item" @click="addBtn" icon="el-icon-circle-plus-outline" type="primary" plain round size="mini">添加按钮</el-button>
    
    <div class="card-botton" v-if="show" v-for=" (item,index) in optionModel.cardTopButton">
      <div class="list-item">
        <el-input v-model="item.name" placeholder="名称" style="width:100px"/>
        <el-select v-model="item.btnClass" placeholder="样式" style="width:100px">
          <el-option label="备注" value="beizhu-btn"></el-option>
          <el-option label="其他" value="title-btn"></el-option>
        </el-select>
        <el-button  icon="el-icon-edit" size="mini"  @click="addFun(index)" class="add-click-func">添加方法</el-button>
        <i  class="el-icon-delete"   @click="delFun(index)"> </i>
      </div>
    </div>
    <el-dialog title="按钮事件添加" :visible.sync="showBtnEventDialogFlag"
               v-if="showBtnEventDialogFlag" :show-close="true" class="small-padding-dialog" v-dialog-drag
               append-to-body :close-on-click-modal="false" :close-on-press-escape="false" :destroy-on-close="true">
      <el-alert type="info" :closable="false" title="button.click(){"></el-alert>
      <code-editor :mode="'javascript'" :readonly="false" v-model="formEventHandlerCode" ref="ecEditor1"></code-editor>
      <el-alert type="info" :closable="false" title="}"></el-alert>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showBtnEventDialogFlag = false">
          {{i18nt('designer.hint.cancel')}}</el-button>
        <el-button type="primary" @click="saveFormEventHandler">
          {{i18nt('designer.hint.confirm')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import i18n from "@/utils/i18n"
  import CodeEditor from '@/components/code-editor/index'
  export default {
    name: "cardTopButton-editor",
    mixins: [i18n],
    components: {
      CodeEditor,
    },
    props: {
      designer: Object,
      selectedWidget: Object,
      optionModel: Object,
    },
    data() {
      return {
        showBtnEventDialogFlag:false,
        currentIndex:0,
        formEventHandlerCode:'',
        show:true
      }
    },
    methods: {
      refresh() {
        this.show = false;
        this.$nextTick(() => {
            this.show = true;
        });
      },
      addBtn(){
        this.optionModel.cardTopButton.push({
          name:'按钮',
          btnClass:'title-btn',
          clickFunc:''
        });
        this.refresh()
      },
      addFun(index){
        this.currentIndex=index;
        this.formEventHandlerCode=this.optionModel.cardTopButton[this.currentIndex].clickFunc;
        this.showBtnEventDialogFlag=true;
      },
      delFun(index){
        this.optionModel.cardTopButton.splice(index,1);
      },
      saveFormEventHandler(){
        const codeHints = this.$refs.ecEditor1.getEditorAnnotations()
        let syntaxErrorFlag = false
        if (!!codeHints && (codeHints.length > 0)) {
          codeHints.forEach((chItem) => {
            if (chItem.type === 'error') {
              syntaxErrorFlag = true
            }
          })
          if (syntaxErrorFlag) {
            this.$message.error(this.i18nt('designer.setting.syntaxCheckWarning'))
            return
          }
        }


        //this.formConfig[this.curEventName] = this.formEventHandlerCode
        /* 注意：如果是options新增的事件属性，保存事件代码必须使用$set方法，！！ */
        //this.$set(this.formConfig, this.curEventName, this.formEventHandlerCode)
        this.optionModel.cardTopButton[this.currentIndex].clickFunc= this.formEventHandlerCode
        this.showBtnEventDialogFlag = false
       
      }
    }
  }
</script>

<style scoped>
.list-item{
  display: flex;
  align-items: center;
}
.add-click-func{
  margin: 2px 0px 2px 2px;
}
.el-icon-delete{margin-left: 4px;color: rgb(215, 42, 42);margin-right: 10px;cursor: pointer;font-size: 16px;}
</style>
